// NotificationSubject — Primitive 3.
// Every entity kind that needs to alert users registers a resolver per
// notification kind here. The notifications module fans out across in-app,
// email, and Web Push channels; the publishing module never writes
// notification rows directly. See DOCS/architecture/primitives/notification-subject.md.
import { z } from 'zod';
// ---------------------------------------------------------------------------
// Channel + dedup
// ---------------------------------------------------------------------------
export const NotificationChannel = z.enum(['in-app', 'email', 'push']);
// ---------------------------------------------------------------------------
// NotificationRecipient — what `resolveRecipients` returns per recipient.
// ---------------------------------------------------------------------------
export const NotificationRecipient = z.object({
    /** Resolved user. Null is forbidden — drop the recipient before returning. */
    userId: z.string().uuid(),
    /**
     * Why this user is in the recipient list. Used for in-app rendering
     * ("Replied to your comment" vs. "Replied to a thread you subscribe to").
     */
    reason: z.string().min(1),
    /** Dedups within a window (e.g. 5 minutes for mentions). */
    dedupKey: z.string().min(1),
    /** Channels this user has opted into for this kind, after preferences. */
    channels: z.array(NotificationChannel),
});
// ---------------------------------------------------------------------------
// NotificationPayload — what `buildPayload` returns per recipient.
// ---------------------------------------------------------------------------
export const NotificationPayload = z.object({
    /** Plain string OR an i18n key (renderer auto-detects by prefix). */
    title: z.string(),
    /** Plain string OR an i18n key. */
    body: z.string(),
    /** Deep link the bell badge / email opens. */
    actionUrl: z.string().min(1),
    actorKind: z.string().min(1),
    actorId: z.string().min(1),
    subjectKind: z.string().min(1),
    subjectId: z.string().min(1),
});
//# sourceMappingURL=notification-subject.js.map